import { lazy } from 'react';
export const MyReportsPage = lazy(() => import(/* webpackChunkName: "my-reports" */ '.'));
export default MyReportsPage;
